export default __webpack_public_path__ + "static/media/ppt.b3182d8d.png";